<!--
 * @Author: your name
 * @Date: 2021-08-28 16:59:34
 * @LastEditTime: 2021-09-10 16:53:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-hero-bump-website-front\src\components\Top.vue
-->
<template>
  <div class="top">
    <div v-if="routerUrl && mobile">
      <router-link tag="div" to="/gameNews/newsList" class="news-phones">
        {{ $t('news_title') }}
      </router-link>
    </div>
    <router-link tag="div" to="/">
      <a class="logo" :class="{ 'logo-en': langEn }">
        <span class="logo-title" v-if="!mobile">{{ $t('logo') }}</span></a>
    </router-link>
    <a href="https://m.me/HeroBumpMobile" class="contact">
      {{ $t('contact') }}
    </a>
    <div class="language" :class="{ 'lan-after': langVisible }">
      <p class="name" @click="toggleLang">{{ $t('news_langs') }}</p>
      <div class="lang" :class="{ fadeIn: langVisible }">
        <p
          v-for="(language, key) in languages"
          :key="key"
          @click="languageChoose(key)"
        >
          {{ language }}
        </p>
      </div>
    </div>
    <div v-if="routerUrl && !mobile" class="center-news">
      <router-link
        tag="div"
        to="/gameNews/newsList"
        :class="['news', store.globalData.lang, 'new-phones-hide']"
      >
        {{ $t('news_title') }}
      </router-link>
      <!-- pc 750下显示 -->
      <router-link
        tag="div"
        to="/gameNews/newsList"
        class="news-phones news-phones-show"
      >{{ $t('news_title') }}</router-link>
    </div>
  </div>
</template>
<script>
import { userAgent } from '../utils/index.js'
export default {
  data () {
    return {
      languages: {
        zhEn: 'English',
        zhCHT: '繁体中文'
      },
      langVisible: false
    }
  },
  computed: {
    langValue () {
      return this.languages[this.store.globalData.lang] || 'English'
    },
    langEn () {
      return this.store.globalData.lang === 'zhEn'
    },
    routerUrl () {
      return this.$route.path === '/'
    },
    mobile () {
      return userAgent().mobile
    }
  },
  methods: {
    languageChoose (key) {
      this.store.changeData('globalData', {
        lang: key
      })
      this.$i18n.locale = key
      this.langVisible = false
    },
    toggleLang () {
      this.langVisible = !this.langVisible
    }
    // toggleLangIn () {
    //   this.langVisible = true
    // },
    // toggleLangOut () {
    //   this.langVisible = false
    // }
  }
}
</script>
<style lang="less" scoped>
@import url('../styles/mixin.less');
.contact {
  position: absolute;
  right: 530px;
  line-height: 70px;
  color: #fff;
  cursor: pointer;
  text-decoration: none;
}
.get-width-height('@lang') when(@lang='zhEn') {
  height: 38px;
  width: 128px;
}
.center-news {
  position: absolute;
  right: 200px;
  top: 15px;
}
.top {
  width: 100%;
  height: 70px;
  position: absolute;
  // background: linear-gradient(to right, #666565bf, #262424bf);
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 100;
  border-bottom: 1px solid #dbc952;
  top: 0;
  .news {
    height: 38px;
    width: 128px;
    line-height: 40px;
    // position: absolute;
    // right: 195px;
    // top: 80px;
    font-weight: bold;
    .mixin-lang-bg('/assets/pc/{lang}/new.png');
    color: #fff;
    cursor: pointer;
    &:hover {
      .mixin-lang-bg('/assets/pc/{lang}/new-hover.png');
      color: #806212;
    }
    &.zhEn {
      width: 188px !important;
      background-repeat: no-repeat !important;
      right: 168px;
    }
  }
  .news-phones-show {
    display: none;
  }
  .news-phones {
    height: 40px;
    // width: 100px;
    line-height: 40px;
    position: absolute;
    right: 214px;
    top: 80px;
    background-color: #000;
    border: solid 1px #ffde00;
    color: #fff;
    padding: 0 10px;
    &:hover {
      background-color: #ffde00;
      color: #4b4141;
    }
  }
  .logo {
    display: block;
    position: absolute;
    left: 200px;
    top: 8px;
    width: 185px;
    height: 73px;
    background: url('../assets/logo-ch.png') no-repeat;
    background-size: contain;
    text-decoration: none;
  }
  .logo-title {
    display: block;
    // position: absolute;
    // left: 290px;
    // top: 30px;
    margin: 22px 0 0 83px;
    text-decoration: none;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
  .logo-en {
    width: 188px;
    background: url('../assets/logo.png') no-repeat;
    background-size: contain;
  }
  .lan-after {
    .name {
      color: #ffde00;
      &:hover::after {
        border-top: 0 !important;
        border-bottom: 8px solid #ffde00;
      }
      &::after {
        border-top: 0 !important;
        border-bottom: 8px solid #ffde00 !important;
      }
    }
  }
  .language {
    position: absolute;
    right: 380px;
    width: 140px;
    line-height: 70px;
    color: #fff;
    cursor: pointer;
    .name {
      &:hover {
        color: #ffde00;
      }
      &::after {
        content: '';
        position: absolute;
        right: 19px;
        width: 0;
        height: 0;
        top: 31px;
        border: 4px solid transparent;
        border-top: 8px solid #fff;
      }
      &:hover::after {
        border-top: 8px solid #ffde00;
      }
    }

    .lang {
      width: 100%;
      // opacity: 0;
      display: none;
      color: #c6c6c6;
      background: rgba(54, 49, 49, 0.8);
      p {
        border-bottom: 1px solid #4b4141;
        transition: all 0.2s linear;
        &:hover {
          color: #ffde00;
        }
        &:hover .name::after {
          border-top: 0 !important;
          border-bottom: 8px solid #ffde00;
        }
        &:last-child {
          border: none;
        }
      }
      &.fadeIn {
        // opacity: 1;
        display: block;
        transition: all 0.2s linear;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .center-news {
    position: initial;
  }
  .contact {
    display: none;
  }
  .top {
    width: 100%;
    height: 1.05rem;
    position: relative;
    .news {
      font-size: 0.26rem;
      height: 0.6rem;
      line-height: 0.6rem;
      // position: absolute;
      // right: 2.2rem;
      // top: 0.24rem;
      background-color: transparent;
      border: solid 1px #fff;
      color: #fff;
      cursor: pointer;
      border-radius: 0.3rem;
      padding: 0 0.2rem;
      &:hover {
        background-color: #ffde00;
        color: #4b4141;
      }
    }
    .news-phones-show {
      display: block;
    }
    .new-phones-hide {
      display: none;
    }
    .news-phones {
      font-size: 0.26rem;
      height: 0.6rem;
      line-height: 0.6rem;
      position: absolute;
      right: 2.2rem;
      top: 0.24rem;
      background-color: transparent;
      border: solid 1px #fff;
      color: #fff;
      cursor: pointer;
      border-radius: 0.3rem;
      padding: 0 0.2rem;
      &:hover {
        background-color: #ffde00;
        color: #4b4141;
      }
    }
    .logo {
      display: block;
      position: absolute;
      left: 0.2rem;
      top: 0.12rem;
      width: 2.29rem;
      height: 0.84rem;
      background: url('../assets/app/logoapp.png') no-repeat;
      background-size: 100% 100%;
    }
    .logo-title {
      display: none;
    }
    .logo-en {
      width: 2.31rem;
      background: url('../assets/app/logoapp-en.png') no-repeat;
      background-size: 100%;
    }
    .language {
      user-select: none;
      position: absolute;
      right: 0.2rem;
      width: 1.7rem;
      font-size: 0.26rem;
      line-height: 1.02rem;
      color: #fff;
      cursor: pointer;
      .name {
        margin-top: 0.24rem;
        height: 0.6rem;
        line-height: 0.6rem;
        border: 1px #fff solid;
        border-radius: 0.3rem;
        &:after {
          content: '';
          position: absolute;
          right: 0.08rem;
          width: 0;
          height: 0;
          top: 0.5rem;
          border: 0.1rem solid transparent;
          border-top: 0.12rem solid #fff;
        }
        &:hover::after {
          border-top: 0.12rem solid #ffde00;
        }
      }
      .lang {
        width: 100%;
        opacity: 0;
        color: #c6c6c6;
        margin-top: 0.2rem;
        background: rgba(54, 49, 49, 0.8);
        p {
          border-bottom: 1px solid #4b4141;
        }
        &.fadeIn {
          opacity: 1;
          transition: all 0.2s linear;
        }
      }
    }
  }
}
</style>
